import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { dashboardAPI as apiConfig } from '../../../axiosConfig';

const SLICE_NAME = 'loyaltyPoints';
const GET_LP_RATES = SLICE_NAME + '/rates';
const UPDATE_LP_RATES = SLICE_NAME + '/rates/update';
const GET_LP_CONFIG = SLICE_NAME + '/config';
const UPDATE_LP_CONFIG = SLICE_NAME + '/config/update';

export const getLoyaltyPointsRates = createAsyncThunk(
  GET_LP_RATES,
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await apiConfig.get('/mcc/fetch/loyalty-rates', {
        params: payload,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const getLoyaltyPointsConfig = createAsyncThunk(
  GET_LP_CONFIG,
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await apiConfig.get('/mcc/fetch/loyalty-config', {
        params: payload,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const updateLPRates = createAsyncThunk(
  UPDATE_LP_RATES,
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await apiConfig.post('/mcc/update/loyalty-rates');
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const updateLPConfig = createAsyncThunk(
  UPDATE_LP_CONFIG,
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await apiConfig.post('/mcc/update/loyalty-config');
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

const loyaltyPointsSlice = createSlice({
  name: SLICE_NAME,
  initialState: {
    isFetchingLPRates: false,
    loyaltyPointsRates: null,

    isFetchingLPConfig: false,
    loyaltyPointsConfig: null,

    isUpdatingLPRates: false,
    isUpdatingLPConfig: false,
  },
  reducers: {
    resetLPRates(state) {
      state.isFetchingLPRates = false;
      state.loyaltyPointsRates = null;
    },
    resetLPConfig(state) {
      state.isFetchingLPConfig = false;
      state.loyaltyPointsConfig = null;
    },
  },
  extraReducers: {
    [getLoyaltyPointsRates.pending]: (state) => {
      state.isFetchingLPRates = true;
      state.loyaltyPointsRates = null;
    },
    [getLoyaltyPointsRates.rejected]: (state) => {
      state.isFetchingLPRates = false;
      state.loyaltyPointsRates = null;
    },
    [getLoyaltyPointsRates.fulfilled]: (state, { payload }) => {
      state.isFetchingLPRates = false;
      state.loyaltyPointsRates = payload;
    },
    [getLoyaltyPointsConfig.pending]: (state) => {
      state.isFetchingLPConfig = true;
      state.loyaltyPointsConfig = null;
    },
    [getLoyaltyPointsConfig.rejected]: (state) => {
      state.isFetchingLPConfig = false;
      state.loyaltyPointsConfig = null;
    },
    [getLoyaltyPointsConfig.fulfilled]: (state, { payload }) => {
      state.isFetchingLPConfig = false;
      state.loyaltyPointsConfig = payload;
    },
    [updateLPRates.pending]: (state) => {
      state.isUpdatingLPRates = true;
    },
    [updateLPRates.rejected]: (state) => {
      state.isUpdatingLPRates = false;
    },
    [updateLPRates.fulfilled]: (state) => {
      state.isUpdatingLPRates = false;
    },
    [updateLPConfig.pending]: (state) => {
      state.isUpdatingLPConfig = true;
    },
    [updateLPConfig.rejected]: (state) => {
      state.isUpdatingLPConfig = false;
    },
    [updateLPConfig.fulfilled]: (state) => {
      state.isUpdatingLPConfig = false;
    },
  },
});

export const selectIsFetchingLPRates = (state) =>
  state.conversionRates.loyaltyPoints.isFetchingLPRates;

export const selectLoyaltyPointsRates = (state) =>
  state.conversionRates.loyaltyPoints.loyaltyPointsRates;

export const selectIsUpdatingLPRates = (state) =>
  state.conversionRates.loyaltyPoints.isUpdatingLPRates;

export const selectIsFetchingLPConfig = (state) =>
  state.conversionRates.loyaltyPoints.isFetchingLPConfig;

export const selectLoyaltyPointsConfig = (state) =>
  state.conversionRates.loyaltyPoints.loyaltyPointsConfig;

export const selectIsUpdatingLPConfig = (state) =>
  state.conversionRates.loyaltyPoints.isUpdatingLPConfig;

export const loyaltyActions = loyaltyPointsSlice.actions;

export default loyaltyPointsSlice.reducer;
